import React from "react";

const OfferCardView = ({ data }) => {
   // Limita el título a 20 palabras
    const maxWords = 15;
    const tituloArray = data.Titulo ? data.Titulo.split(" ") : [];
    const tituloRecortado =
        tituloArray.length > maxWords
            ? tituloArray.slice(0, maxWords).join(" ") + "..."
            : data.Titulo;    
    return (
        <div
            style={{
                width: 303,
                height: 250,
                background: "transparent",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                boxSizing: "border-box",
                margin: "8px 0"
            }}
        >
            <a
                href={data.URL_AdsFanpage}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", width: "100%" }}
            >
                <div
                    style={{
                        width: "100%",
                        height: 200,
                        borderRadius: 8,
                        overflow: "hidden",
                        background: "#eaeaea",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <img
                        src={data.Imagen}
                        alt={data.Titulo}
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover"
                        }}
                    />
                </div>
            </a>
            <div
                style={{
                    width: "100%",
                    marginTop: 8,
                    textAlign: "left"
                }}
            >
                <a
                    href={data.URL_AdsFanpage}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        color: "#003366",
                        fontWeight: 600,
                        fontSize: 16,
                        textDecoration: "none",
                        lineHeight: "1.2"
                    }}
                >
                      {tituloRecortado}
                </a>
                
                <div style={{ marginTop: 6, display: "flex", flexDirection: "column", gap: "6px" }}>
                    <div>
                        <span style={{ fontWeight: "bold" }}>Página Web: </span>
                        {data.LandingPage && (
                            <a
                                href={data.LandingPage}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: "#1976d2", wordBreak: "break-all" }}
                            >
                                {data.LandingPage.length > 60
                                    ? data.LandingPage.slice(0, 60) + "..."
                                    : data.LandingPage}
                            </a>
                        )}
                    </div>

                    <div>
                        <span style={{ fontWeight: "bold" }}>Fanpage: </span>
                        {data.URL_AdsFanpage && (
                            <a
                                href={data.URL_AdsFanpage}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Abrir fanpage en una nueva pestaña"
                                style={{
                                    color: "#1976d2",
                                    textDecoration: "none",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 6
                                }}
                            >
                                Ver fanpage
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={{ marginLeft: 4 }}>
                                    <path d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3z"></path>
                                    <path d="M5 5h6v2H7v10h10v-4h2v6H5V5z"></path>
                                </svg>
                            </a>
                        )}
                    </div>

                    <div>
                        <span style={{ fontWeight: "bold" }}>Duplicados: </span>
                        <span>
                            {data.NumberOfAds}
                            {data.NumberOfAds > 10 ? " 🔥" : ""}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfferCardView;